import {
  animate,
  animateChild,
  group,
  keyframes,
  query,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

// Animates an element's width with a jiggle effect
// minWidth - initial width (px)
// maxWidth - final width (px)
// jiggle   - jiggle effect (px)
export const expandCollapseJiggleAnimation = trigger('expandCollapse', [
  state(
    'expanded',
    style({
      width: '{{maxWidth}}',
    }),
    { params: { maxWidth: '100', jiggle: '5' } }
  ),
  state(
    'collapsed',
    style({
      width: '{{minWidth}}',
    }),
    { params: { minWidth: '50', jiggle: '5' } }
  ),
  transition('expanded => collapsed', [
    group([
      animate(
        '1s ease-in-out',
        keyframes([
          style({ width: '{{maxWidth}}', offset: 0 }),
          style({ width: 'calc({{minWidth}} - {{jiggle}}px)', offset: 0.7 }),
          style({ width: '{{minWidth}}', offset: 1 }),
        ])
      ),
      query('@expandCollapse', animateChild(), { optional: true }),
      query('@rotate', animateChild(), { optional: true }),
      query('@slideFade', animateChild(), { optional: true }),
      query('@iHiddenShown', animateChild(), { optional: true }),
    ]),
  ]),
  transition('collapsed => expanded', [
    group([
      animate(
        '1s ease-in-out',
        keyframes([
          style({ width: '{{minWidth}}', offset: 0 }),
          style({ width: 'calc({{maxWidth}} + {{jiggle}}px)', offset: 0.7 }),
          style({ width: '{{maxWidth}}', offset: 1 }),
        ])
      ),
      query('@expandCollapse', animateChild(), { optional: true }),
      query('@rotate', animateChild(), { optional: true }),
      query('@slideFade', animateChild(), { optional: true }),
      query('@iHiddenShown', animateChild(), { optional: true }),
    ]),
  ]),
]);

// Animates an element's rotation with a jiggle effect
// startRotation    - initial rotation (deg)
// startWithJiggle  - initial rotation - jiggle (deg)
// endRotation      - final rotation (deg)
// endWithJiggle  - final rotation + jiggle (deg)
export const rotateJiggleAnimation = trigger('rotate', [
  state(
    'start',
    style({
      transform: 'rotate({{startRotation}}deg)',
    }),
    { params: { startRotation: '0', startWithJiggle: '-5' } }
  ),
  state(
    'end',
    style({
      transform: 'rotate({{endRotation}}deg)',
    }),
    { params: { endRotation: '180', endWithJiggle: '185' } }
  ),
  transition('start => end', [
    animate(
      '300ms ease-in-out',
      keyframes([
        style({ transform: 'rotate({{startRotation}}deg)', offset: 0 }),
        style({ transform: 'rotate({{endWithJiggle}}deg)', offset: 0.7 }),
        style({ transform: 'rotate({{endRotation}}deg)', offset: 1 }),
      ])
    ),
  ]),
  transition('end => start', [
    animate(
      '300ms ease-in-out',
      keyframes([
        style({ transform: 'rotate({{endRotation}}deg)', offset: 0 }),
        style({ transform: 'rotate({{startWithJiggle}}deg)', offset: 0.7 }),
        style({ transform: 'rotate({{startRotation}}deg)', offset: 1 }),
      ])
    ),
  ]),
]);

// Animates an element's position with a fade and jiggle effect
// startPosition  - initial left position (px)
// endPosition    - final left position (px)
// jiggle         - jiggle effect (px)
export const slideFadeJiggleAnimation = trigger('slideFade', [
  state(
    'hidden',
    style({
      opacity: '0',
      left: '{{startPosition}}px',
    }),
    { params: { startPosition: '0', jiggle: '5' } }
  ),
  state(
    'shown',
    style({
      opacity: '1',
      left: '{{endPosition}}px',
    }),
    { params: { endPosition: '10', jiggle: '5' } }
  ),
  transition('hidden => shown', [
    animate(
      '650ms ease-in-out',
      keyframes([
        style({ opacity: '0', left: '{{startPosition}}px', offset: 0 }),
        style({ opacity: '1', left: 'calc({{endPosition}}px + {{jiggle}}px)', offset: 0.7 }),
        style({ opacity: '1', left: '{{endPosition}}px', offset: 1 }),
      ])
    ),
  ]),
  transition('shown => hidden', [
    animate(
      '650ms ease-in-out',
      keyframes([
        style({ opacity: '1', left: '{{endPosition}}px', offset: 0 }),
        style({ opacity: '0', left: 'calc({{startPosition}}px - {{jiggle}}px)', offset: 0.7 }),
        style({ opacity: '0', left: '{{startPosition}}px', offset: 1 }),
      ])
    ),
  ]),
]);
